import { useEffect, useState } from "react";
import ChatArea from "../../components/chat/ChatArea";
import ChatSidebar from "../../components/chat/ChatSidebar";
import useTawkControl from "../../hooks/useTawkControl";

const Chat = () => {
  const [user, setUser] = useState(null)
  return (
    <div className="h-[calc(100vh-64px)] w-full flex overflow-hidden">
      <ChatSidebar setUser={setUser} />
      <ChatArea user={user} />
    </div>
  );
};

export default Chat;
